import { useCallback } from 'react';

export const useFeatureTracking = () => {
  const noop = useCallback(async (..._args: any[]) => {}, []);

  return {
    trackMatchCreation: noop,
    trackTournamentInteraction: noop,
    trackGroupInteraction: noop,
    trackMessaging: noop,
    trackPollInteraction: noop,
    trackProfileInteraction: noop,
    trackSettingsChange: noop,
    trackSearch: noop,
    trackButtonClick: noop,
    trackLinkClick: noop,
    trackFormInteraction: noop,
    trackError: noop,
  };
};
